<template>
  <div class="rabattvollmacht-container">
    <div class="semanticsection-title2">
      <span class="primary--text ueber">{{ header }}</span>
      <site-tooltip class="ml-3">Der Rabatt bleibt grundsätzlich während der gesamten Vertragslaufzeit bestehen.
      </site-tooltip>
    </div>
    <div :class="{oekoFont: oeko, oekoColor: oeko, 'secondary--text': !oeko }"
         class="subueber mb-5">{{ rabattText }}
    </div>
    <v-row no-gutters>

      <div class="dmb-form-text limit-text"><span>{{ minimumText }}</span></div>
      <v-slider v-if="oeko"
                v-model="oekopunkte"
                :min="0"
                :max="maxRabatt"
                track-color="rgba(0,0,0,0.87);"
                style="--midlabel: '5';"
                class="pl-3"
                ticks />
      <v-slider v-else
                v-model="rabattProzent"
                :disabled="couponRabatt"
                :min="0"
                :max="maxRabatt"
                track-color="rgba(0,0,0,0.87);"
                style="--midlabel: '5%';"
                class="pl-3"
                ticks />
      <div class="dmb-form-text limit-text">{{ maximumText }}
      </div>
    </v-row>
  </div>
</template>

<script>
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";

export default {
  name: "Rabattvollmacht",
  mixins: [twowayBinding, ValidationMixin],
  props: {
    oeko: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maxRabatt: 10
    };
  },
  computed: {
    ...mapTwoWay([
      "rabattProzent",
      "oekopunkte",
      "coupon"
    ]),
    couponRabatt() {
      if (this.$store.getters.rabattVollmacht) return false;
      if ( (this.coupon ?? "").length ) return true;
      return false;
    },
    rabattText() {
      if (this.oeko) {
        return `${this.oekopunkte} Ökopunkt${this.oekopunkte !== 1 ? "e" : ""}`;
      } else {
        return `${this.rabattProzent}% Rabatt`;
      }
    },
    header() {
      return this.oeko ? "Ökopunkte" : "Rabattvollmacht";
    },
    minimumText() {
      return this.oeko ? "0" : "0%";
    },
    maximumText() {
      return this.oeko ? this.maxRabatt : `${this.maxRabatt}%`;
    }
  }
};
</script>

<style>

.rabattvollmacht-container .semanticsection-title2 {
  display: flex;
  align-items: flex-end;
}

.rabattvollmacht-container .oekoFont {
  font-family: "Indie Flower", Roboto, sans-serif;
  font-weight: 600 !important;
}

.rabattvollmacht-container .oekoColor {
  color: #afcb04 !important;
}

.rabattvollmacht-container .limit-text {
  padding-top: 2px;
}

.rabattvollmacht-container div.v-slider::before {
  content: "";
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 50%;
  margin-left: -1px;
  width: 2px;
  background-color: rgba(0,0,0,.26);
  pointer-events: none;
}

.rabattvollmacht-container div.v-input__slider {
  position: relative;
}

.rabattvollmacht-container div.v-input__slider::before {
  content: var(--midlabel);
  position: absolute;
  bottom: 6px;
  left: 50%;
  margin-left: -12px;
  width: 40px;
  text-align: center;
  font-size: 16px;
  color: rgba(0,0,0,.87);
  pointer-events: none;
}
</style>
